import React from "react";
import { Col, Row } from "react-bootstrap";

export default function StatContainer(props) {
  return (
    <Row className="m-0 sub-heading mt-5">
      <Col sm={12} className="p-0">
        <h2>{props.title}</h2>
        <div className="box p-4">{props.children}</div>
      </Col>
    </Row>
  );
}
